// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"58ad0f66","977":"995341cb"}[chunkId] + ".chunk.js";
};